<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 text-light py-lg-5"
                class="border-0">
            <!-- <template>
                <div class="text-center mb-3">
                    <small>Sign in with</small>
                </div>
                <div class="btn-wrapper text-center">
                    <base-button type="neutral">
                        <img slot="icon" src="img/icons/common/github.svg">
                        Github
                    </base-button>

                    <base-button type="neutral">
                        <img slot="icon" src="img/icons/common/google.svg">
                        Google
                    </base-button>
                </div>
            </template> -->
            <template>
              <div class="text-center text-dark mb-5">
                <h3>Welcome to Central Hub</h3>
              </div>
              <div class="text-center text-muted mb-2">
                <small>Sign in with credentials</small>
              </div>
              <form role="form">
                <base-input alternative
                            class="mb-3"
                            placeholder="Email"
                            addon-left-icon="ni ni-email-83"
                            v-model="email">
                </base-input>
                <base-input alternative
                            type="password"
                            placeholder="Password"
                            addon-left-icon="ni ni-lock-circle-open"
                            v-model="password">
                </base-input>
                <base-checkbox class="text-muted">
                  Remember me
                </base-checkbox>
                <div class="text-center">
                  <base-button type="secondary" class="my-4" v-on:click="triggerSignInProcess">Sign In</base-button>
                </div>
              </form>
            </template>
            <div class="row mt-3">
              <!-- <div class="col-6">
                <a href="#" class="text-light">
                  <small>Forgot password?</small>
                </a>
              </div> -->
              <!-- <div class="col-6 text-right">
                <a href="#" class="text-light">
                  <small>Create new account</small>
                </a>
              </div> -->
            </div>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import BaseInput from '../assets/base/BaseInput.vue'
import Card from '../assets/base/Card.vue'
import BaseButton from '../assets/base/BaseButton.vue'
import BaseCheckbox from '../assets/base/BaseCheckbox.vue'

export default {
  components: {
    BaseInput,
    Card,
    BaseButton,
    BaseCheckbox
  },
  data() {
    return {
      email: "",
      password:""
    }
  },
  methods: {
    triggerSignInProcess: function() {
      const current = this
      if (current.validateSignInRequirements()) {
        let data = {
          email: current.email,
          password: current.password
        }
        current.$store.dispatch("user/login", data).then(token=>{
          sessionStorage.setItem("accessToken", token)
          current.$store.commit("user/storeToken", token)
        }).catch(error=>{
          current.$notify({
            group: 'foo',
            title: 'Login Failed',
            text: 'Kindly check your credentials for any mistakes.',
            type: "error"
          });
        });
      }
      else {
        current.$notify({
          group: 'foo',
          title: 'Login Failed',
          text: 'Kindly check your credentials for any mistakes.',
          type: "error"
        });
      }
    },
    validateSignInRequirements: function() {
      if (this.email!="" && this.password!="") {
        return true
      }
      else {
        return false;
      }
    }
  }
};
</script>
<style>
</style>
